
import React from 'react';
import { Star, StarHalf } from 'lucide-react';

interface ProductRatingProps {
  rating: number;
  size?: number;
  className?: string;
}

const ProductRating: React.FC<ProductRatingProps> = ({ 
  rating, 
  size = 16, 
  className = ''
}) => {
  // Calculate full and half stars
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  
  return (
    <div className={`flex items-center ${className}`}>
      {/* Full stars */}
      {Array.from({ length: fullStars }).map((_, i) => (
        <Star 
          key={`full-${i}`} 
          className="text-yellow-400 fill-yellow-400" 
          size={size} 
        />
      ))}
      
      {/* Half star if applicable */}
      {hasHalfStar && (
        <StarHalf 
          className="text-yellow-400 fill-yellow-400" 
          size={size} 
        />
      )}
      
      {/* Empty stars */}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <Star 
          key={`empty-${i}`} 
          className="text-gray-300" 
          size={size} 
        />
      ))}
    </div>
  );
};

export default ProductRating;
